
import { Component, Mixins, Emit, Watch } from "vue-property-decorator";
import store from "@/store";
import { isVisibleHomeAlignment } from "@/lib/functions";
import {
  HOME_ALIGNMENT_HASH,
  scrollToHomeAlignmentAnchor,
} from "@/lib/scrollAnchor";
import Home from "@/mixins/Home";
import HomeMainVisual from "@/components/home/HomeMainVisual/HomeMainVisual.vue";
import HomeSlider from "@/components/home/HomeSlider/HomeSlider.vue";
import NaviSerchnavi from "@/components/navi/NaviSerchnavi/NaviSerchnavi.vue";
import HomeFavoritelist from "@/components/home/HomeFavoritelist/HomeFavoritelist.vue";
import HomeCampaignlist from "@/components/home/HomeCampaignlist/HomeCampaignlist.vue";
import HomeNewslist from "@/components/home/HomeNewslist/HomeNewslist.vue";
import HomePickuplist from "@/components/home/HomePickuplist/HomePickuplist.vue";
import HomeHistory from "@/components/home/HomeHistory/HomeHistory.vue";
import HomeSns from "@/components/home/HomeSNS/HomeSNS.vue";
import HomeSpecialoffer from "@/components/home/HomeSpecialoffer/HomeSpecialoffer.vue";
import HomeAlignment from "@/components/home/HomeAlignment/HomeAlignment.vue";
import ButtonTodayLowestPrice from "@/components/button/ButtonTodayLowestPrice.vue";
import HomeAlignmentShareholder from "@/components/home/HomeAlignment/HomeAlignmentShareholder.vue";
import HomePopupBanner from "@/components/home/HomePopupBanner/HomePopupBanner.vue";
import { getBeginnerNaviUrl } from "@/lib/functions";
import ButtonToday from "@/mixins/ButtonToday";
// import ButtonLineMini from "@/components/button/ButtonLineMini.vue";
// import ButtonRewardsClub from "@/components/button/ButtonRewardsClub.vue";
@Component({
  components: {
    HomeMainVisual,
    HomeSlider,
    NaviSerchnavi,
    HomeFavoritelist,
    HomeCampaignlist,
    HomeNewslist,
    HomePickuplist,
    HomeHistory,
    HomeSns,
    HomeSpecialoffer,
    HomeAlignment,
    HomeAlignmentShareholder,
    ButtonTodayLowestPrice,
    HomePopupBanner,
    // ButtonLineMini,
    // ButtonRewardsClub,
  },
})
export default class HomeJa extends Mixins(Home, ButtonToday) {
  private showPopupBanner = false;
  private showPopupBanner2 = !sessionStorage.getItem("first-beginner-popup");
  private beginnerNaviUrl = getBeginnerNaviUrl(store.getters["auth/group"]);
  private openModalSearchNavi(): void {
    this.showPopupBanner2 = false;
    store.commit("searchmodal/open", "ModalSearchnavi");
  }

  get account(): string {
    return store.getters["auth/account"];
  }
  get newsCancelUrl(): string {
    return "/pages/mghcp-note";
    // return process.env.VUE_APP_NEWS_CANCEL_URL;
  }
  get mghrecUrl(): string {
    return "/pages/mghrc2025-note";
    // return process.env.VUE_APP_MGHRWC_URL;
  }
  get showAlignment(): boolean {
    return isVisibleHomeAlignment(store.getters["auth/group"]);
  }

  private closePopupBanner2(): void {
    this.showPopupBanner2 = false;
  }

  @Watch("showPopupBanner2", { immediate: true })
  private onFirstPopupVisibleChange(visible: boolean) {
    if (!visible) {
      sessionStorage.setItem("first-beginner-popup", "1");
      this.showPopupBanner = !sessionStorage.getItem("first-banner");
    }
  }

  @Emit()
  private clickTodayBanner() {
    window.gtag("event", "CrntFunction", {
      event_category: "todayHotel",
      event_label: "todayHotel02",
    });
  }

  get token(): boolean {
    return store.getters["auth/token"];
  }

  get isShareholder(): boolean {
    return store.getters["auth/isShareholder"];
  }

  get showRewardsClubButton(): boolean {
    if (!store.getters["auth/group"]) {
      return false;
    }
    const whiteList =
      process.env.VUE_APP_SHOW_REWARDS_CLUB_BUTTON_WHITE_LIST.split(",") || [];
    return whiteList.includes(store.getters["auth/group"]);
  }

  @Watch("$route.hash")
  private onRouteHashChange(hash: string) {
    if (this.loaded && hash === HOME_ALIGNMENT_HASH) {
      this.$nextTick(() => this.scrollToHomeAlignmentIfNeeded());
    }
  }

  private scrollToHomeAlignmentIfNeeded(attempt = 0): void {
    if (this.$route.hash !== HOME_ALIGNMENT_HASH) {
      return;
    }
    const maxAttempts = 40;
    const intervalMs = 50;
    if (scrollToHomeAlignmentAnchor("smooth")) {
      return;
    }
    if (attempt < maxAttempts) {
      setTimeout(
        () => this.scrollToHomeAlignmentIfNeeded(attempt + 1),
        intervalMs
      );
    }
  }

  private async getSlider() {
    const refs: any = this.$refs;
    if (refs.slider) {
      await refs.slider.getEntries();
    }
    this.loaded = true;
    store.commit("loaded", true);
    this.$nextTick(() => this.scrollToHomeAlignmentIfNeeded());
  }
  private mounted() {
    const refs: any = this.$refs;
    const arr = [];
    if (refs.slider) {
      this.getSlider();
      // arr.push(refs.slider.getEntries());
    }
    if (refs.favoritelist) {
      arr.push(refs.favoritelist.getEntries());
    }
    if (refs.campaignlist) {
      arr.push(refs.campaignlist.getEntries());
    }
    if (refs.newslist) {
      arr.push(refs.newslist.getEntries());
    }
    if (refs.pickuplist) {
      arr.push(refs.pickuplist.getEntries());
    }
    if (refs.historylist) {
      arr.push(refs.historylist.getEntries());
    }
    if (refs.specialoffer) {
      arr.push(refs.specialoffer.getEntries());
    }
    Promise.all(arr);
  }
}
